import React, { useState } from "react";

const Banner = () => {
  // The 'key' is the secret. Changing it forces React to redraw the image from scratch.
  const [replayKey, setReplayKey] = useState(0);

  const handleHover = () => {
    // This updates the key, forcing the browser to reload the GIF instantly from Frame 0
    setReplayKey(prev => prev + 1);
  };

  return (
    <div className="cinematic-wrapper" onMouseEnter={handleHover}>
      <img
        // KEY PROP: The magic that allows replay
        key={replayKey} 
        
        // Replace with your 'Loop Once' GIF path
        src="/assets/21.gif" 
        
        alt="Cinematic Experience"
        className="hero-gif"
      />
      
      {/* Premium Overlay: Adds depth and hints at interactivity */}
      <div className="overlay-vignette">
        <div className="interaction-hint">
          <span className="hint-icon"></span>
          <span className="hint-text"></span>
        </div>
      </div>
    </div>
  );
};

export default Banner;